import { render, staticRenderFns } from "./studentAbsenceList.vue?vue&type=template&id=fd7a7fb0&scoped=true&"
import script from "./studentAbsenceList.vue?vue&type=script&lang=js&"
export * from "./studentAbsenceList.vue?vue&type=script&lang=js&"
import style0 from "./studentAbsenceList.vue?vue&type=style&index=0&id=fd7a7fb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd7a7fb0",
  null
  
)

export default component.exports